import $ from 'jquery';

class UserService {
  static updateLocation(location) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/update_location',
        dataType: 'json',
        data: { location },
        success(data) {
          $(document).trigger('location_changed');
          resolve(data);
        },
        error(jqXHR, textStatus, errorThrown) {
          reject(new Error(JSON.stringify({
            status: jqXHR.status,
            responseText: jqXHR.responseText,
            textStatus,
            errorThrown,
          })));
        },
      });
    });
  }
}

export default UserService;
